import { render, staticRenderFns } from "./ContractorDocumentTypeForm.vue?vue&type=template&id=6471842e"
import script from "./ContractorDocumentTypeForm.vue?vue&type=script&lang=js"
export * from "./ContractorDocumentTypeForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports